const config = require('../server.config.json');
const stack = process.env.REACT_APP_IGO_STACK || 'default';

export default config[stack];
